import React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export function JuniorIcon({ fill = 'black', size = 'xsmall' }: IconProps) {
    const fillStyles = cn(Styles[fill], Styles.fill);

    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.998 2H7.54117L7.42695 2.00631C6.90174 2.06473 6.49291 2.52133 6.49291 3.07595L6.49223 10.1047L6.44771 10.1031L3.04558 10.114C2.46769 10.1155 2 10.5968 2 11.1899V15.0737C2 15.3578 2.10947 15.6304 2.30453 15.832L4.09508 17.6823C4.29187 17.8856 4.55957 18 4.83881 18H9.17478C9.45413 18 9.72192 17.8856 9.91873 17.6821L11.6842 15.8566L12.7096 21.1381C12.8045 21.6389 13.2263 21.9999 13.7166 21.9999H18.2639C18.7546 21.9999 19.1767 21.6383 19.2711 21.1369L21.9805 7.27419C22.1049 6.61346 21.6185 5.99901 20.9719 5.99995L17.0655 6.00644L16.9484 6.01352C16.487 6.06895 16.1123 6.44425 16.0496 6.93377L16.0006 7.30712L15.9549 6.93909C15.8882 6.40681 15.4527 6.00861 14.9371 6.00861H12.0463V3.07595C12.0463 2.48172 11.5769 2 10.998 2ZM9.94892 4.15163V14.5954L8.73792 15.8476H5.27526L4.09626 14.6303V12.2623L5.57182 12.2571L5.57388 13.6571L6.27701 14.3961L7.80733 14.3959L8.58942 13.6556L8.58923 4.15163H9.94892ZM19.7262 8.13898L17.4186 19.862H14.5595L12.2751 8.14509H14.0503L15.8093 17.3593C15.8505 17.5749 16.1586 17.5764 16.2018 17.3612L18.0561 8.14203L19.7262 8.13898Z"
            />
            <mask
                id="mask0_6029_9465"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="20"
                height="20"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.998 2H7.54117L7.42695 2.00631C6.90174 2.06473 6.49291 2.52133 6.49291 3.07595L6.49223 10.1047L6.44771 10.1031L3.04558 10.114C2.46769 10.1155 2 10.5968 2 11.1899V15.0737C2 15.3578 2.10947 15.6304 2.30453 15.832L4.09508 17.6823C4.29187 17.8856 4.55957 18 4.83881 18H9.17478C9.45413 18 9.72192 17.8856 9.91873 17.6821L11.6842 15.8566L12.7096 21.1381C12.8045 21.6389 13.2263 21.9999 13.7166 21.9999H18.2639C18.7546 21.9999 19.1767 21.6383 19.2711 21.1369L21.9805 7.27419C22.1049 6.61346 21.6185 5.99901 20.9719 5.99995L17.0655 6.00644L16.9484 6.01352C16.487 6.06895 16.1123 6.44425 16.0496 6.93377L16.0006 7.30712L15.9549 6.93909C15.8882 6.40681 15.4527 6.00861 14.9371 6.00861H12.0463V3.07595C12.0463 2.48172 11.5769 2 10.998 2ZM9.94892 4.15163V14.5954L8.73792 15.8476H5.27526L4.09626 14.6303V12.2623L5.57182 12.2571L5.57388 13.6571L6.27701 14.3961L7.80733 14.3959L8.58942 13.6556L8.58923 4.15163H9.94892ZM19.7262 8.13898L17.4186 19.862H14.5595L12.2751 8.14509H14.0503L15.8093 17.3593C15.8505 17.5749 16.1586 17.5764 16.2018 17.3612L18.0561 8.14203L19.7262 8.13898Z"
                    fill="white"
                />
            </mask>
            <g mask="url(#mask0_6029_9465)">
                <rect width="24" height="24" className={fillStyles} />
            </g>
        </svg>
    );
}
